(function(angular){
	'use strict';
	
	angular
		.module('mediaGalleryModule')
		.controller('MediaGalleryModalController', [
			'$scope',
			'$timeout',
			'$window',
			'close',
			'ignoreClose',
			'investorUpdateId',
			'mediaItems',
			'mixpanelFactory',
			'selectedIndex',
			MediaGalleryModalFunction
		]);
	
	function MediaGalleryModalFunction(
		$scope,
		$timeout,
		$window,
		close,
		ignoreClose,
		investorUpdateId,
		mediaItems,
		mixpanelFactory,
		selectedIndex
	){
		var mediaGalleryModal = this;

		mediaGalleryModal.ignoreClose = ignoreClose;
		mediaGalleryModal.investorUpdateId = investorUpdateId;
		mediaGalleryModal.mediaItems = mediaItems;
		mediaGalleryModal.selectedIndex = selectedIndex;
		mediaGalleryModal.youtubePlayerSettings = {
			showinfo: 0,
			modestbranding: 1,
			iv_load_policy: 3,
			color: '#f69f1a',
			rel: 0
		};

		updateSelectedItem(true);

		mixpanelFactory.track('Media Modal Action', {
			'Action' : 'Open',
			'Item Index' : mediaGalleryModal.selectedIndex,
			'Investor Update ID': mediaGalleryModal.investorUpdateId
		});

		function stopVideo() {
			if(angular.isDefined(mediaGalleryModal.youtubePlayer) && angular.isDefined(mediaGalleryModal.youtubePlayer.stopVideo)) {
				mediaGalleryModal.youtubePlayer.stopVideo();
			}
		}

		function updateSelectedItem(justOpened) {
			mediaGalleryModal.selected = mediaGalleryModal.mediaItems[mediaGalleryModal.selectedIndex];

			if(mediaGalleryModal.selected.mediaItemType === 'VIDEO') {
				mediaGalleryModal.selected.mediaLoaded = true;
				if(justOpened) {
					mediaGalleryModal.youtubePlayerSettings.autoplay = 1;
				} else {
					mediaGalleryModal.youtubePlayerSettings.autoplay = 0;
				}
			}
		}

		mediaGalleryModal.next = function (){
			mediaGalleryModal.selectedIndex++;
			mediaGalleryModal.selectedIndex = mediaGalleryModal.selectedIndex > (mediaGalleryModal.mediaItems.length - 1) ? 0 : mediaGalleryModal.selectedIndex;
			updateSelectedItem();
			stopVideo();

			mixpanelFactory.track('Media Modal Action', {
				'Action' : 'Next',
				'Item Index' : mediaGalleryModal.selectedIndex,
				'Investor Update ID': mediaGalleryModal.investorUpdateId
			});
		};

		mediaGalleryModal.previous = function() {
			mediaGalleryModal.selectedIndex--;
			mediaGalleryModal.selectedIndex = mediaGalleryModal.selectedIndex < 0 ? (mediaGalleryModal.mediaItems.length - 1) : mediaGalleryModal.selectedIndex;
			updateSelectedItem();
			stopVideo();

			mixpanelFactory.track('Media Modal Action', {
				'Action' : 'Previous',
				'Item Index' : mediaGalleryModal.selectedIndex,
				'Investor Update ID': mediaGalleryModal.investorUpdateId
			});
		};

		mediaGalleryModal.close = function() {
			$window.document.onkeyup = null;
			stopVideo();
			mixpanelFactory.track('Media Modal Action', {
				'Action' : 'Close',
				'Item Index' : mediaGalleryModal.selectedIndex,
				'Investor Update ID': mediaGalleryModal.investorUpdateId
			});
			close();
		};

		$window.document.onkeyup = function(e) {
			if(e.keyCode === 37) {
				mediaGalleryModal.previous();
			} else if(e.keyCode === 39) {
				mediaGalleryModal.next();
			} else if (e.keyCode === 27) {
				mediaGalleryModal.close();
			}

			$scope.$apply();
		};

		$scope.$on('youtube.player.playing', function ($event, player) {
			mixpanelFactory.track('Media Modal Video', {
				'Video URL' : mediaGalleryModal.selected.sourceUrl,
				'Action' : 'Play',
				'Investor Update ID': mediaGalleryModal.investorUpdateId
			});
		});

		$scope.$on('youtube.player.paused', function ($event, player) {
			mixpanelFactory.track('Media Modal Video', {
				'Current Time' : player.getCurrentTime(),
				'Video URL' : mediaGalleryModal.selected.sourceUrl,
				'Action' : 'Pause',
				'Investor Update ID': mediaGalleryModal.investorUpdateId
			});
		});

		$scope.$on('lazyImage:loaded', function(evt) {
			mediaGalleryModal.mediaItems[mediaGalleryModal.selectedIndex].mediaLoaded = true;
			$scope.$apply();
		});

	}
})(window.angular);